import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { AtSign, Timer, MessageSquareReply } from "lucide-react";

export function EngagementWidget({ engagement }) {
  const navigate = useNavigate();
  if (!engagement) return null;

  return (
    <Card className="p-5 border-slate-200" data-testid="engagement-widget">
      <div className="flex items-center justify-between mb-4">
        <p className="font-display font-semibold text-slate-900 flex items-center gap-2">
          <MessageSquareReply size={17} style={{ color: "var(--tenant-primary)" }} /> Engagement
        </p>
        <span className="text-xs text-slate-400">Mentions awaiting reply &amp; response SLA</span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="h-8 w-8 rounded-md flex items-center justify-center" style={{ background: "#F7941E1a" }}>
              <AtSign size={16} style={{ color: "#F7941E" }} />
            </span>
            <div>
              <p className="text-xs uppercase tracking-wider text-slate-400">Open mentions awaiting reply</p>
              <p className="text-xl font-bold text-slate-900" data-testid="open-mentions-count">{engagement.open_mentions_count}</p>
            </div>
          </div>
          <div className="space-y-1.5">
            {engagement.stalled_mentions.length === 0 && <p className="text-sm text-slate-400">No stalled mentions — great job! 🎉</p>}
            {engagement.stalled_mentions.map((m, i) => (
              <button key={`${m.ticket_id || "n"}-${i}`} onClick={() => m.link && navigate(m.link)} data-testid="stalled-mention-item"
                className="w-full flex items-center gap-2 px-2 py-2 rounded-md hover:bg-slate-50 text-left">
                <AtSign size={13} className="text-sky-500 shrink-0" />
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-slate-800 truncate">{m.ticket_title}</p>
                  <p className="text-[11px] text-slate-400">waiting on {m.waiting_on}</p>
                </div>
                {m.age_hours != null && (
                  <span className={`text-[11px] px-1.5 py-0.5 rounded flex items-center gap-1 ${m.age_hours >= 24 ? "bg-red-50 text-red-600" : "bg-slate-100 text-slate-500"}`}>
                    <Timer size={11} />{m.age_hours >= 24 ? `${Math.round(m.age_hours / 24)}d` : `${Math.round(m.age_hours)}h`}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider text-slate-400 mb-2">Avg first response by client</p>
          <div className="divide-y divide-slate-100 border border-slate-100 rounded-md">
            {engagement.per_client_response.map((c) => (
              <div key={c.client_name} className="flex items-center gap-3 px-3 py-2" data-testid="client-response-row">
                <span className="text-sm text-slate-700 flex-1 truncate">{c.client_name}</span>
                <span className="text-[11px] text-slate-400">{c.open_tickets} open</span>
                <span className={`text-xs font-medium ${c.avg_first_response_hours != null && c.avg_first_response_hours > 24 ? "text-red-600" : "text-slate-700"}`}>
                  {c.avg_first_response_hours != null ? `${c.avg_first_response_hours}h` : "—"}
                </span>
              </div>
            ))}
            {engagement.per_client_response.length === 0 && <p className="text-center text-sm text-slate-400 py-4">No clients yet.</p>}
          </div>
        </div>
      </div>
    </Card>
  );
}
